const Form096EN = {
    title: " (Former eform number: EDB 113)",
    stepName: {
        information: "Basic Information",
        partA: "Personal Information",
        partB: "Declaration",
        confirmation: "Confirmation",
    },
    notes: {
        notesTitle: "Notes for completing the Application",
        declaration: "I hereby declare that:",
        declaration1:
            "I have read the Notes for Completing the Application Form at Part I.",
        declaration2:
            "I understand that only the latest submission will be processed if I have submitted more than one application.",
        declaration3: `I understand that if I wilfully give any false information or withhold any material information in this application form, or fail to notify the recruiting grade/department any subsequent change of information provided, it will render me liable to disqualification for employment by the Government or termination of employment, if already employed by the Government.`,
        declaration4: `I consent to the Government making any necessary enquiries for purposes relating to recruitment by and employment with the Government and for the verification of the information given above. I authorise all government departments and other organisations or agencies to release any record or information as may be required for these enquiries (including, inter alia, obtaining a reference/performance appraisal report(s) from my current and/or previous employer(s) before offer of appointment; obtaining my medical examination reports, medical board reports or medical records from relevant authorities/agencies/medical personnel and transferring of such data to other authorities/agencies/medical personnel; and making enquiries from relevant government departments/institutions/agencies regarding my academic/language/professional qualifications and obtaining relevant records and transferring of such data to other government departments/authorities/agencies for qualifications assessment). I hereby authorize the Commissioner of Police, or his representative, to release full particulars of any and all criminal convictions recorded against me to relevant government departments/authorities/agencies. I also agree to my fingerprint impressions being taken by the Police in connection with this application, if required for the purpose of verifying my criminal records.`,
        declaration5: `I understand and accept that the information given above will be provided to government departments and other organisations or agencies authorised to process the information for recruitment, other employment-related and human resource management-related purposes, e.g. qualifications assessment, medical examination, employer reference and integrity checking, etc. as may be necessary.`,
        agreeTips: "I have read the notes for completing the Application.",
    },
    comma: ", ",
    tooltip: {
        university:
            "Note: If you possess non-local academic qualifications, you may need to apply for the qualifications assessment from the Hong Kong Council for Accreditation of Academic and Vocational Qualifications.",
        multiSelect: "You may select more than one option.",
        threeSubject:
            "You may enter up to three subjects for secondary and primary level.",
        notesTips: "Notes for completing the Application",
    },
    label: {
        partI: "Part I",
        partITips:
            "Application for the next school year is accepted between 1 April to 31 August of the current school year.",
        payPeriod:
            "Applying for a daily-paid supply / monthly-paid temporary teaching post",
        servingPeriod:
            "Period available for serving as a daily-paid supply teacher / monthly-paid temporary teacher",
        servingDateTips:
            "If the period available for serving as a daily-paid supply teacher / monthly-paid temporary teacher is not for the whole school year, please indicate the period available",
        startDateOfServ: "from",
        endDateOfServ: "to",
        partII: "Part II",
        title1: "(i) Personal particulars",
        nameTitle: "Name:\n(Same as that on HKID card)",
        english: "(English)",
        chinese: "(Chinese)",
        surname: "Surname",
        otherName: "Other Name",
        englishSurname: "Name (Same as that on HKID card) (English) Surname",
        englishOtherName:
            "Name (Same as that on HKID card) (English) Other Name",
        chineseSurname: "Name (Same as that on HKID card) (Chinese) Surname",
        chineseOtherName:
            "Name (Same as that on HKID card) (Chinese) Other Name",
        residentHK: "Status of Resident of Hong Kong",
        documentType: "Document Type",
        hkidCardNo: "HKID Card No.",
        otherDocumentNo: "Other Document No.",
        idIssuePlace: "Place of Issue",
        dateBirth: "Date of Birth",
        sexCode: "Sex",
        teacherRegistrationNo: "Teacher Registration No.",
        title2: "(ii) Contact details",
        emailAddress: "Email Address",
        district: "Residential District",
        telNo: "Residential Telephone No.",
        mobilePhoneNo: "Mobile Phone No.",
        title3: "(iii) Qualifications",
        titleThreeTips:
            "(Please provide the originals and copies of the supporting documents for (A) to (C) below when attending the school interview, e.g. certificates / transcripts etc.)",
        universityTitle: "(A) University",
        instUnivName: "Name of University",
        qualDegree: "Degree Obtained",
        yearObtain: "Year Obtained",
        major: "Major",
        minor: "Minor",
        trainingTitle: "(B) Teacher Training",
        instUnivCollName: "Name of University / College of Education",
        trainCert: "Degree / Certificate / Diploma Obtained",
        schLvEdu: "Primary / Secondary Education",
        lprEngPth: "(C) Language Proficiency Requirement (LPR)",
        lprEngChiTips:
            "(Please select appropriate box(es) if you have met the LPR through exemption and/or assessment.)",
        title4: "(iv) Teaching experience",
        teachingExperienceTips:
            "(Please select the box below to indicate whether you have been a graduate / non-graduate monthly-paid teacher in any local primary / secondary day school offering formal curriculum.)",
        teachingExperienceConfirmTips:
            "Whether you have been a graduate / non-graduate monthly-paid teacher in any local primary / secondary day school offering formal curriculum",
        experienceYear: "Year of Full-time Teaching Experience:",
        teachExperYear: "year(s)",
        teachExperMonth: "month(s)",
        teachExperTips:
            "Note: Daily-paid teaching experience should not be included.",
        noTeachExper:
            "Please provide the original and copies of letter/certificate of service issued by the previous school(s) when attending the school interview.",
        fullTimeExperSchool:
            "Please tick the box to indicate that you have teaching experience in S4 or above",
        title5: "(v) Location & level of school preferred",
        location: "Location",
        schoolLevel: "School Level",
        title6: "(vi) Subject(s) Qualified to teach",
        secondarySchool: "Secondary School",
        secondarySubject1: "Subject 1",
        secondarySubject2: "Subject 2",
        secondarySubject3: "Subject 3",
        secSubj1S4OrAbove: "with teaching experience in S4 or above",
        secSubj2S4OrAbove: "with teaching experience in S4 or above",
        secSubj3S4OrAbove: "with teaching experience in S4 or above",
        primarySchool: "Primary School",
        primarySubject1: "Subject 1",
        primarySubject2: "Subject 2",
        primarySubject3: "Subject 3",
        subjectName: "Subject Name",
        capaAcqTips: "Capability in teaching non-language subjects in English:",
        acqTips:
            "(i.e. You have met the <u style='color: blue'>teacher capability criteria</u> for using English to teach non-language subjects. You may be asked by the recruiting school to provide documents to prove that you have met the requirements of the teacher capability criteria for non-language subject teachers using English as the Medium of Instruction. Please read the relevant information by following the path: <b>EDB Homepage > Education System and Policy > Primary and Secondary School Education > Applicable to Secondary School > Medium of Instruction > Reference Documents > Frequently asked questions</b> (Section related to Teacher Capability))",
        capaNaTips:
            "(e.g. using Chinese to teach non-language subjects, or teaching only language subjects)",
        title7: "(vii) Are you a retired / resigned civil servant in EDB?",
        leftCivilServiceTips: "If yes, please indicate\xa0",
        dateLeftCivilService: "the date on which you left EDB",
        receivingPension: "and whether you are receiving pension",
        title8: "(viii) Are you an aided / government school teacher who has been approved to join the Early Retirement Scheme?",
        ersIndicTips:
            "If yes, please refer to <u>Point 12</u> of the Notes for Completing the Application Form at Part I.",
        partIII: "Part III",
        chineseNameCode: "Chinese Name in Code",
        placeBirth: "Place of Birth",
        residentialAddress1: "Residential Address Line 1",
        residentialAddress2: "Residential Address Line 2",
        residentialCountry: "Residential Country / Region",
        title9: "(ix) Has your registered teacher or permitted teacher status been cancelled/refused?",
        title10:
            "(x) To the best of your knowledge, have you ever received any reprimand/warning/advisory letters issued by EDB due to your professional misconduct?",
        title11:
            "(xi) To the best of your knowledge, were/are you being investigated by schools or EDB over professional misconduct allegations?",
        title12:
            "(xii) To the best of your knowledge, have you ever been convicted of any criminal offence in Hong Kong or elsewhere?",
        title13:
            "(xiii) To the best of your knowledge, are you involved in any ongoing criminal proceedings or investigations (including but not limited to arrest or apprehension by the police)?",
        detail: "If yes, please give details",
    },
    select: {
        payPeriodOption: {
            D: "Daily-paid supply teacher",
            M: "Monthly-paid temporary teacher",
            E: "Either one of the above",
        },
        servingPeriodOption: {
            C: "Current School Year ({{schoolYear}} School Year)",
            N: "Next School Year ({{nextSchoolYear}} School Year)",
            B: "Current and next school year",
        },
        residentHKOption: {
            P: "Permanent Resident",
            N: "Non-permanent Resident",
        },
        documentTypeOption: {
            "01": "HKIC",
            "02": "PASSPORT",
            "03": "RE-ENTRY PERMIT",
            "05": "HK DOC OF IDENTITY FOR VISA PURPOSES",
            "06": "ENTRY PERMIT (DEPENDENT FOR N MONTHS)",
            "07": "DECLARTION OF ID FOR VISA PURPOSE",
            "08": "ONE WAY PERMIT",
            "09": "OTHERS",
        },
        placeIssueOption: {
            999: "OTHERS",
            AUS: "AUSTRALIA",
            AUT: "AUSTRIA",
            BRA: "BRAZIL",
            BRI: "BRITAIN",
            CAN: "CANADA",
            CHI: "CHINA",
            FRA: "FRANCE",
            GER: "GERMANY",
            HK: "HONG KONG",
            IND: "INDIA",
            JPN: "JAPAN",
            KOR: "KOREA",
            MAC: "MACAU",
            MYS: "MALAYSIA",
            NLD: "NETHERLANDS, THE",
            NPL: "NEPAL",
            NZL: "NEW ZEALAND",
            PAK: "PAKISTAN",
            PHL: "PHILIPPINES, THE",
            PRT: "PORTUGAL",
            SGP: "SINGAPORE",
            SPA: "SPAIN",
            SWI: "SWITZERLAND",
            THA: "THAILAND",
            TWN: "TAIWAN",
            UK: "UNITED KINGDOM",
            USA: "UNITED STATES, THE",
            VNM: "VIETNAM",
        },
        placeBirthOption: {
            HK: "Hong Kong",
            MO: "Macao",
            TW: "Taiwan",
            CN: "Mainland",
            AF: "Afghanistan",
            AX: "Aland Islands",
            AL: "Albania",
            DZ: "Algeria",
            AS: "American Samoa",
            AD: "Andorra",
            AO: "Angola",
            AI: "Anguilla",
            AQ: "Antarctica",
            AG: "Antigua and Barbuda",
            AR: "Argentina",
            AM: "Armenia",
            AW: "Aruba",
            AU: "Australia",
            AT: "Austria",
            AZ: "Azerbaijan",
            BS: "Bahamas",
            BH: "Bahrain",
            BD: "Bangladesh",
            BB: "Barbados",
            BY: "Belarus",
            BE: "Belgium",
            BZ: "Belize",
            BJ: "Benin",
            BM: "Bermuda",
            BT: "Bhutan",
            BO: "Bolivia",
            BA: "Bosnia and Herzegovina",
            BW: "Botswana",
            BV: "Bouvet Island",
            BR: "Brazil",
            IO: "British Indian Ocean Territory",
            BN: "Brunei Darussalam",
            BG: "Bulgaria",
            BF: "Burkina Faso",
            BI: "Burundi",
            KH: "Cambodia",
            CM: "Cameroon",
            CA: "Canada",
            CV: "Cape Verde",
            KY: "Cayman Islands",
            CF: "Central African Republic",
            TD: "Chad",
            CL: "Chile",
            CX: "Christmas Island",
            CC: "Cocos (Keeling) Islands",
            CO: "Colombia",
            KM: "Comoros",
            CG: "Congo",
            CK: "Cook Islands",
            CR: "Costa Rica",
            CI: "Cote D'Ivoire",
            HR: "Croatia",
            CU: "Cuba",
            CY: "Cyprus",
            CZ: "Czech Republic",
            KP: "Korea",
            DK: "Denmark",
            DJ: "Djibouti",
            DM: "Dominica",
            DO: "Dominican Republic",
            EC: "Ecuador",
            EG: "Egypt",
            SV: "El Salvador",
            GQ: "Equatorial Guinea",
            ER: "Eritrea",
            EE: "Estonia",
            ET: "Ethiopia",
            FK: "Falkland Islands (Malvinas)",
            FO: "Faroe Islands",
            FM: "Federated States of Micronesia",
            FJ: "Fiji",
            FI: "Finland",
            FR: "France",
            GF: "French Guiana",
            PF: "French Polynesia",
            TF: "French Southern Territories",
            GA: "Gabon",
            GM: "Gambia",
            DE: "Germany",
            GN: "Guinea",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HT: "Haiti",
            HM: "Heard Island and Mcdonald Islands",
            VA: "Holy See (Vatican City State)",
            HN: "Honduras",
            HU: "Hungary",
            IS: "Iceland",
            IM: "Isle of Man",
            IL: "Israel",
            IT: "Italy",
            JM: "Jamaica",
            JP: "Japan",
            JE: "Jersey",
            JO: "Jordan",
            KZ: "Kazakhstan",
            KE: "Kenya",
            KI: "Kiribati",
            KW: "Kuwait",
            KG: "Kyrgyzstan",
            LA: "Lao People's Democratic Republic",
            LV: "Latvia",
            LB: "Lebanon",
            LS: "Lesotho",
            LR: "Liberia",
            LY: "Libyan Arab Jamahiriya",
            LI: "Liechtenstein",
            LT: "Lithuania",
            LU: "Luxembourg",
            MG: "Madagascar",
            MW: "Malawi",
            MY: "Malaysia",
            MV: "Maldives",
            ML: "Mali",
            MT: "Malta",
            MH: "Marshall Islands",
            MQ: "Martinique",
            MR: "Mauritania",
            MU: "Mauritius",
            YT: "Mayotte",
            MX: "Mexico",
            MC: "Monaco",
            MN: "Mongolia",
            ME: "Montenegro",
            MS: "Montserrat",
            MA: "Morocco",
            MZ: "Mozambique",
            MM: "Myanmar",
            NA: "Namibia",
            NR: "Nauru",
            NP: "Nepal",
            NL: "Netherlands",
            AN: "Netherlands Antilles",
            NC: "New Caledonia",
            NZ: "New Zealand",
            NI: "Nicaragua",
            NE: "Niger",
            NG: "Nigeria",
            NU: "Niue",
            NF: "Norfolk Island",
            MP: "Northern Mariana Islands",
            NO: "Norway",
            OM: "Oman",
            PK: "Pakistan",
            PW: "Palau",
            PS: "Palestinian Territory, Occupied",
            PA: "Panama",
            PG: "Papua New Guinea",
            PY: "Paraguay",
            PE: "Peru",
            PH: "Philippines",
            PN: "Pitcairn",
            PL: "Poland",
            PT: "Portugal",
            PR: "Puerto Rico",
            QA: "Qatar",
            KR: "Republic of Korea",
            MK: "Republic of Macedonia",
            MD: "Republic of Moldova",
            RE: "Reunion",
            RO: "Romania",
            RU: "Russian Federation",
            RW: "Rwanda",
            SH: "Saint Helena",
            KN: "Saint Kitts and Nevis",
            LC: "Saint Lucia",
            PM: "Saint Pierre and Miquelon",
            VC: "Saint Vincent and The Grenadines",
            WS: "Samoa",
            SM: "San Marino",
            ST: "Sao Tome and Principe",
            SA: "Saudi Arabia",
            SN: "Senegal",
            RS: "Serbia",
            SC: "Seychelles",
            SL: "Sierra Leone",
            SG: "Singapore",
            SK: "Slovakia",
            SI: "Slovenia",
            SB: "Solomon Islands",
            SO: "Somalia",
            ZA: "South Africa",
            GS: "South Georgia and The South Sandwich Islands",
            ES: "Spain",
            LK: "Sri Lanka",
            SD: "Sudan",
            SR: "Suriname",
            SJ: "Svalbard and Jan Mayen",
            SZ: "Swaziland",
            SE: "Sweden",
            CH: "Switzerland",
            SY: "Syrian Arab Republic",
            TJ: "Tajikistan",
            TZ: "Tanzania",
            TH: "Thailand",
            CD: "Congo",
            TL: "Timor-Leste",
            TG: "Togo",
            TK: "Tokelau",
            TO: "Tonga",
            TT: "Trinidad and Tobago",
            GE: "Georgia",
            TR: "Turkey",
            TM: "Turkmenistan",
            TC: "Turks and Caicos Islands",
            TV: "Tuvalu",
            UG: "Uganda",
            UA: "Ukraine",
            AE: "United Arab Emirates",
            GB: "United Kingdom",
            US: "United States",
            UM: "United States Minor Outlying Islands",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VU: "Vanuatu",
            VE: "Venezuela",
            VN: "Viet Nam",
            VG: "Virgin Islands, British",
            VI: "Virgin Islands, U.S.",
            WF: "Wallis and Futuna",
            EH: "Western Sahara",
            IN: "India",
            ID: "Indonesia",
            IQ: "Iraq",
            IE: "Ireland",
            IR: "Islamic Republic of Iran",
            TN: "Tunisia",
            GH: "Ghana",
            GI: "Gibraltar",
            GL: "Greenland",
            GD: "Grenada",
            GP: "Guadeloupe",
            GU: "Guam",
            GT: "Guatemala",
            GG: "Guernsey",
            YE: "Yemen",
            ZM: "Zambia",
            ZW: "Zimbabwe",
            GR: "Greece",
        },
        // placeBirthOption: {
        //     999: "Others",
        //     AUS: "Australia",
        //     AUT: "Austria",
        //     BRA: "Brazil",
        //     BRI: "Britain (Expired on 20.12.2017)",
        //     CAN: "Canada",
        //     CHI: "Mainland China",
        //     FRA: "France",
        //     GER: "Germany",
        //     HK: "Hong Kong",
        //     IDN: "Indonesia",
        //     IND: "India",
        //     JPN: "Japan",
        //     KOR: "Korea",
        //     MAC: "Macau",
        //     MYS: "Malaysia",
        //     NLD: "Netherlands",
        //     NPL: "Nepal",
        //     NZL: "New Zealand",
        //     PAK: "Pakistan",
        //     PHL: "Philippines",
        //     PRT: "Portugal",
        //     SGP: "Singapore",
        //     SPA: "Spain",
        //     SWI: "Switzerland",
        //     THA: "Thailand",
        //     TWN: "Taiwan",
        //     UK: "United Kingdom",
        //     USA: "United States of America",
        //     VNM: "Vietnam",
        //     INA: "Information not available",
        // },
        districtOption: {
            // "": "INAPPLICABLE",
            A: "CENTRAL AND WESTERN",
            B: "WAN CHAI",
            C: "EASTERN",
            D: "SOUTHERN",
            E: "YAU TSIM MONG",
            F: "SHAM SHUI PO",
            G: "KOWLOON CITY",
            H: "WONG TAI SIN",
            J: "KWUN TONG",
            K: "TSUEN WAN",
            L: "TUEN MUN",
            M: "YUEN LONG",
            N: "NORTH",
            P: "TAI PO",
            Q: "SAI KUNG",
            R: "SHA TIN",
            S: "KWAI TSING",
            T: "ISLANDS",
            X: "MAINLAND CHINA",
        },
        sexOption: {
            M: "M",
            F: "F",
        },
        radioChooseOption: {
            Y: "Yes",
            N: "No",
        },
        radioChooseOption2: {
            Y: "Yes",
            N: "N/A",
        },
        locationOption: {
            hkIsland: "Hong Kong Island",
            kowloon: "Kowloon",
            newTerritoriesEast: "New Territories East",
            newTerritoriesWest: "New Territories West",
        },
        schoolLevelOption: {
            2: "Primary",
            3: "Secondary",
        },
        capaOption: {
            CAPA_ACQ: "Qualifications acquired",
            CAPA_NA: "Not applicable",
        },
        lprEngPthOption: {
            english: "LPR for English",
            putonghua: "LPR for Putonghua",
        },
        schLvEduOption: {
            "": "Not Specified",
            primary: "Primary",
            secondary: "Secondary",
        },
    },
    serial: {
        num0: "(a)",
        num1: "(b)",
        num2: "(c)",
        num3: "(d)",
        num4: "(e)",
        num5: "(f)",
    },
    serialChild: {
        num0: "(ⅰ)",
        num1: "(ⅱ)",
        num2: "(ⅲ)",
        num3: "(ⅳ)",
    },
    noteList: [
        // "<u>For the teaching posts of the <b>current school year</b>, applicants may submit applications throughout the school year</u>, and the validity period is no more than six months. For example, for the applications submitted in September, the validity period is up to the end of February of the current school year. For the applications submitted in October, the validity period is up to the end of March of the current school year. After the validity period, if applicants would like to keep on applying for the posts, they could submit applications afresh. Nevertheless, all applications for the teaching posts of the current school year will be invalid at the end of the school year on 31 August.",
        // "<u>For the teaching posts of the <b>next school year</b>, applicants can submit applications from 1 April to 31 August of the current school year</u>, and the validity period is up to 30 September of the next school year. Applications for the teaching posts of the next school year submitted in other period will not be accepted.",
        "All data submitted by applicants will be discarded at the end of the validity period of the applications.",
        // "After submitting your application, if you wish to update your information, please re-submit the application.",
        "Information submitted by applicants will be sent to government schools for their reference. If there are any suitable vacancies, the schools will contact the applicants direct by phone for an interview.",
        "Applicants are <u><b>not</b></u> required to attach the relevant documentary proof of academic qualification or teaching experience when submitting the applications, but they must bring along the relevant documents for the scrutiny of schools when attending interviews. If the applicants possess non-local academic qualifications, they must apply for the qualifications assessment from the Hong Kong Council for Accreditation of Academic and Vocational Qualifications in advance to ascertain that they have fulfilled the academic requirements for the teaching posts concerned.",
        "If you are invited to attend an interview by school, please bring along the following documents for scrutiny:",
        "Being government organizations, government schools must be in line with the government policies and have implemented anti-epidemic measures. Applicants are required to comply with these measures in order to be considered for appointment.",
        `Starting from the 2023/24 school year, all newly-appointed teachers in public sector schools, DSS schools and Scheme-KGs are required to pass the BLNST conducted by the Civil Service Bureau or the Education Bureau (EDB) in order to be considered for appointment. This requirement is applicable to monthly-paid temporary teachers appointed on non-civil service terms in government schools. For details, please visit the EDB website (<a href="https://www.edb.gov.hk/en/sch-admin/admin/about-sch-staff/blnst/index.html" target="_blank">https://www.edb.gov.hk/en/sch-admin/admin/about-sch-staff/blnst/index.html</a>).`,
        "The EDB attaches great importance to the professional conduct of teachers. Applications from teachers who have committed a serious crime or illegal act or involved in professional misconduct covering those teachers who have received reprimand / warning / advisory letters or their teacher registration status have been cancelled / their applications for teacher registration have been refused by the EDB would not be considered without notification.",
        `The Administration has accepted the recommendation of the Law Reform Commission to establish the Sexual Conviction Record Check (SCRC) scheme and the Hong Kong Police Force has launched the scheme since 1 December 2011. The scheme is only applicable to prospective employees seeking child-related work or work relating to mentally incapacitated persons in organizations or enterprises (including schools). Given the importance of protecting our students, schools should adopt the scheme and request prospective employees to undergo SCRC at the advanced stage of the employment process. Applications for SCRC should be submitted by the prospective employees voluntarily. Details of the SCRC scheme are available at the Hong Kong Police Force homepage (<a href="http://www.police.gov.hk/scrc" target="_blank">http://www.police.gov.hk/scrc</a>).`,
        "Any teacher who has participated in the Early Retirement Scheme (ERS) for aided school teachers or in the ERS for teaching grades staff in the EDB is not allowed to take up full-time or part-time teaching posts (including those created by government funds for the purpose of providing additional teachers to schools, but excluding those teaching posts on daily-rated part-time jobs not more than 89 days) in aided, caput, direct subsidy scheme and government schools after the date of early retirement.",
        "For the personal data provided, please note the following:",
    ],
    note7: [
        "the original Hong Kong Identity Card;",
        "the original and copies of academic qualifications such as degree certificate, transcript, Teacher's Certificate or other teacher training certificates, HKDSE Examination Certificate or HKCEE Certificate and / or HKALE Certificate;",
        "the original and copy of Basic Law and National Security Law Test (BLNST) Result (applicable to teachers applying for monthly-paid temporary teaching posts);",
        "the original and copies of letters of release issued by schools you have served; and",
        "the original and copy of Certificate of Registration as a Teacher, if any.",
        // "the original and copy of vaccination records.",
    ],
    note13: [
        "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        "The provision of personal data required by this form and during the processing of this form is obligatory. In the event that you do not provide those personal data, we may not be able to handle or further process your application.",
        "The personal data you provide will be made available to persons working in the EDB. Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        "You have the right to request access to and correction of your personal data held by the EDB. Request for access or correction of personal data should be made in writing to Government Schools Section, EDB, Room 1414, 14/F Wu Chung House, 213 Queen’s Road East, Wan Chai, Hong Kong (Tel No. : 2892 6325).",
    ],
    note13A: [
        "Activities relating to the processing, authentication and counter-checking of <b>employment-related matters</b> including appointments, training and career developments, remuneration and benefits, staff relation, communications and compliance with procedures;",
        "Activities relating to <b>matching of the personal data</b> with the database of relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of <b>employment-related matters</b> mentioned in 10(a)(i) above;",
        "Activities relating to <b>matching of the personal data</b> within the database of the EDB for purposes of verifying / updating records of the EDB, and",
        "Activities relating to compilation of <b>statistics</b>, <b>research</b> and <b>Government publications</b>.",
    ],
    note13C: [
        "other Government bureau and departments for the purposes mentioned in paragraph 10(a) above;",
        "personnel, agent, service provider or organisations engaged by the EDB to provide services or advice for the purposes mentioned in paragraph 10(a) above;",
        "where you have given your prescribed consent to such disclosure; and",
        "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
    ],
    errorMsg: {
        ninYear: "The year obtained must be after {{year}}",
        dateAge: "Age must be equal or larger than 18",
        errObj1: "Please select a day within current school year",
        errObj2: "Within the next school year",
        errObj3: "it should be within the current school year({{curYear}})",
        errObj4: "it should be within the next school year({{nextYear}})",
        errYearObtain:
            "The year obtained must be earlier than the current {{curYear}} year and later than the {{bithYear}} year of birth",
        errTeachExper:
            "The number of years and months of full-time teaching experience cannot be entered as zero at the same time",
        PlaceBirth: "placeBirth shuold not be empty"
    },
};
export default Form096EN;
